module.exports = __webpack_public_path__ + "static/media/Golos_Text_Bold.8ab5e964.woff2";